export default __webpack_public_path__ + "static/media/CANCIONES_DISCO_05.1438aedb.png";